import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ACTION_TYPES, usePoliticalPartyCreateEditDispatch, usePoliticalPartyCreateEditState } from './political-party-create-edit-context';
import PoliticalPartyAppService from '../../../../application/platform/sge/political-party/political-party-app-service';
import { useBaseLayout } from '../../../../components/context/use-base-layout';

export const usePoliticalPartyCreateEditController = () => {
    const navigate = useNavigate();
    const dispatch = usePoliticalPartyCreateEditDispatch();
    const state = usePoliticalPartyCreateEditState();
    const { showMessage, showLoading } = useBaseLayout();
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (state.partyId) {
            showLoading({ open: true });
            PoliticalPartyAppService.getById(Number(state.partyId)).then((data) => {
                dispatch({ type: ACTION_TYPES.setPartyRequest, payload: { name: data.name, abbreviation: data.abbreviation, isActive: data.isActive } });
            }).catch((error: any) => {
                showMessage({ open: true, message: 'Não foi possível carregar os dados do partido', detail: error?.details || error?.message, type: 'error' });
            }).finally(() => {
                showLoading({ open: false });
            });
        }
    }, [state.partyId]);

    function handleOnChange(e: any) {
        const { name, value, checked, type } = e.target;
        dispatch({
            type: ACTION_TYPES.updatePartyRequest,
            payload: { [name]: type === 'checkbox' ? checked : value }
        });
    }

    async function handleSave() {
        if (!state.partyRequest.name || !state.partyRequest.abbreviation) {
            dispatch({ type: ACTION_TYPES.setShowValidationErrors, payload: true });
            return;
        }
        setIsSaving(true);
        try {
            if (state.partyId) {
                await PoliticalPartyAppService.edit(Number(state.partyId), state.partyRequest);
                showMessage({ open: true, message: 'Partido atualizado com sucesso!', type: 'success' });
            } else {
                await PoliticalPartyAppService.add(state.partyRequest);
                showMessage({ open: true, message: 'Partido adicionado com sucesso!', type: 'success' });
            }
            setTimeout(() => navigate('/partidos-politicos'), 1500);
        } catch (error: any) {
            showMessage({ open: true, message: 'Não foi possível salvar o partido', detail: error?.details || error?.message, type: 'error' });
        } finally {
            setIsSaving(false);
        }
    }

    function handleCancel() {
        navigate('/partidos-politicos');
    }

    return { handleOnChange, handleSave, handleCancel, isSaving };
};
